// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* top container left */
.displayComponentHomePageLeftContainerTop {
    flex: 50%;
    padding: 1em;
    padding-left: 3em;
    text-align: center;
    max-width: 40em;
    animation: fadeInGlobal 2s;
}

.displayComponentHomePageLeftimageContainer {
    max-width: 12em;
    max-height: 12em;
    min-width: 12em;
    min-height: 12em;
    margin-left: auto;
    margin-right: auto;
    animation: fadeInGlobal 2s;
}

.displayComponentHomePageLogo {
    max-width: 12em;
}

.displayComponentHomePageTextTopContainer {
    text-align: left;
}

.displayComponentHomePageTextTop {
    font-size: 22px;
}

.displayComponentHomePageBadningContainer {
    display: flex;
    justify-content: center;
}

.displayComponentHomePageBranding1 {
    color: white;
    font-family: var(--googleFont);
    font-weight: 900;
    font-size: 2em;
}

.displayComponentHomePageBranding2 {
    color: var(--HighlightBlue);
    font-family: var(--googleFont);
}

.displayComponentHomePageButtonContainerTop {
    text-align: left;
    display: flex;
    gap: 1em;
    flex-wrap: wrap;
}

/* home button style */
.displayComponentHomePageButton {
    padding: 10px;
    width: 200px;
    background-color: var(--BlueButtonComponentBorderColor);
    background-repeat: no-repeat;
    border: 2px solid var(--BlueButtonComponentBorderColor);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: white;
    font-weight: 800;
    font-size: 14px;
    font-family: var(--googleFont);
    cursor: pointer;
}

.displayComponentHomePageButtonIcon {
    padding: 2px;
    min-width: 100px;
    max-width: 100px;
    background-color: var(--BlueButtonComponentBorderColor);
    background-repeat: no-repeat;
    border: 2px solid var(--BlueButtonComponentBorderColor);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: white;
    font-weight: 800;
    font-family: var(--googleFont);
    cursor: pointer;
}

.displayComponentHomePageButton:hover {
    background-color: var(--DarkBlue);
    border: 2px solid var(--DarkBlue);
    box-shadow: inset 0 0 10px black;
}

.displayComponentHomePageButtonIcon:hover {
    background-color: var(--DarkBlue);
    border: 2px solid var(--DarkBlue);
    box-shadow: inset 0 0 10px black;
}

.displayComponentHomePageIconDisplay {
    max-width: 30px;
    filter: brightness(0) invert(1);
}

@media only screen and (max-width: 1220px) {
    .displayComponentHomePageTextTopContainer {
        text-align: center;
    }

    .displayComponentHomePageButtonContainerTop {
        justify-content: center;
    }
}

@media only screen and (max-width: 540px) {
    .displayComponentHomePageButtonContainerTop {
        gap: 0.5em;
    }

    .displayComponentHomePageTextTop {
        font-size: 18px;
    }

    .displayComponentHomePageLeftimageContainer {
        width: 10em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/displayComponentHomePage/topDisplayLeft/topDisplayLeft.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,YAAY;IACZ,uDAAuD;IACvD,4BAA4B;IAC5B,uDAAuD;IACvD,qDAAqD;IACrD,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uDAAuD;IACvD,4BAA4B;IAC5B,uDAAuD;IACvD,qDAAqD;IACrD,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* top container left */\n.displayComponentHomePageLeftContainerTop {\n    flex: 50%;\n    padding: 1em;\n    padding-left: 3em;\n    text-align: center;\n    max-width: 40em;\n    animation: fadeInGlobal 2s;\n}\n\n.displayComponentHomePageLeftimageContainer {\n    max-width: 12em;\n    max-height: 12em;\n    min-width: 12em;\n    min-height: 12em;\n    margin-left: auto;\n    margin-right: auto;\n    animation: fadeInGlobal 2s;\n}\n\n.displayComponentHomePageLogo {\n    max-width: 12em;\n}\n\n.displayComponentHomePageTextTopContainer {\n    text-align: left;\n}\n\n.displayComponentHomePageTextTop {\n    font-size: 22px;\n}\n\n.displayComponentHomePageBadningContainer {\n    display: flex;\n    justify-content: center;\n}\n\n.displayComponentHomePageBranding1 {\n    color: white;\n    font-family: var(--googleFont);\n    font-weight: 900;\n    font-size: 2em;\n}\n\n.displayComponentHomePageBranding2 {\n    color: var(--HighlightBlue);\n    font-family: var(--googleFont);\n}\n\n.displayComponentHomePageButtonContainerTop {\n    text-align: left;\n    display: flex;\n    gap: 1em;\n    flex-wrap: wrap;\n}\n\n/* home button style */\n.displayComponentHomePageButton {\n    padding: 10px;\n    width: 200px;\n    background-color: var(--BlueButtonComponentBorderColor);\n    background-repeat: no-repeat;\n    border: 2px solid var(--BlueButtonComponentBorderColor);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: white;\n    font-weight: 800;\n    font-size: 14px;\n    font-family: var(--googleFont);\n    cursor: pointer;\n}\n\n.displayComponentHomePageButtonIcon {\n    padding: 2px;\n    min-width: 100px;\n    max-width: 100px;\n    background-color: var(--BlueButtonComponentBorderColor);\n    background-repeat: no-repeat;\n    border: 2px solid var(--BlueButtonComponentBorderColor);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: white;\n    font-weight: 800;\n    font-family: var(--googleFont);\n    cursor: pointer;\n}\n\n.displayComponentHomePageButton:hover {\n    background-color: var(--DarkBlue);\n    border: 2px solid var(--DarkBlue);\n    box-shadow: inset 0 0 10px black;\n}\n\n.displayComponentHomePageButtonIcon:hover {\n    background-color: var(--DarkBlue);\n    border: 2px solid var(--DarkBlue);\n    box-shadow: inset 0 0 10px black;\n}\n\n.displayComponentHomePageIconDisplay {\n    max-width: 30px;\n    filter: brightness(0) invert(1);\n}\n\n@media only screen and (max-width: 1220px) {\n    .displayComponentHomePageTextTopContainer {\n        text-align: center;\n    }\n\n    .displayComponentHomePageButtonContainerTop {\n        justify-content: center;\n    }\n}\n\n@media only screen and (max-width: 540px) {\n    .displayComponentHomePageButtonContainerTop {\n        gap: 0.5em;\n    }\n\n    .displayComponentHomePageTextTop {\n        font-size: 18px;\n    }\n\n    .displayComponentHomePageLeftimageContainer {\n        width: 10em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
